var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseEyeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.74 9.269-5.48 4.644c-.705-.597-1.138-1.414-1.138-2.322 0-1.818 1.733-3.286 3.878-3.286 1.072 0 2.037.367 2.74.964Z",
    stroke: "#000",
    strokeOpacity: 0.65
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.305 5.873C17.409 4.66 15.242 4 13 4 9.176 4 5.612 5.91 3.13 9.213c-.974 1.295-.974 3.47 0 4.764a14.034 14.034 0 0 0 2.936 2.91m3.056 1.615c1.235.44 2.545.679 3.878.679 3.824 0 7.388-1.91 9.87-5.213.974-1.294.974-3.47 0-4.764a15.235 15.235 0 0 0-1.15-1.349",
    stroke: "#000",
    strokeOpacity: 0.65
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.803 12.233c-.282 1.294-1.528 2.35-3.055 2.588m-3.489-.908-8.093 6.855M23.833 2.413l-8.092 6.856",
    stroke: "#000",
    strokeOpacity: 0.65
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseEyeIcon);
export default __webpack_public_path__ + "static/media/closeEyeIcon.2a4a959955700184753065bd8e9fa448.svg";
export { ForwardRef as ReactComponent };